import GoogleAnalyticsTracker from 'utils/tracking/providers/ga';
import { getEnvironmentValue } from 'utils/environment';
import { Nullable } from 'utils/types';

let ga: Nullable<GoogleAnalyticsTracker> = null;

const getAnalyticsInstance = (): GoogleAnalyticsTracker => {
  if (!ga) {
    ga = new GoogleAnalyticsTracker(
      getEnvironmentValue('REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID'),
      getEnvironmentValue('REACT_APP_GTM_ID'),
    );
  }
  return ga;
};

export const trackPageView = (path: string): void => {
  getAnalyticsInstance().trackPageView(path);
};
